import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess } from '@nk/access-block';
import { CachingService } from '@nk/caching-lib';
import {
  AppFeatureKey,
  AppRoleKey,
  CompanyLegalRightCompositeEntity,
  COUNTRY_FEATURES,
  WithUuid,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyLegalRightService {
  constructor(
    private _analysisApiAccess: AnalysisApiClientAccess,
    private _cachingService: CachingService,
  ) {}

  public companyLegalRightCompositeCache = this._cachingService.create(this, this.fetchCompanyLegalRightComposite);
  public fetchCompanyLegalRightComposite(
    companyUuid?: string,
    rightsholderCompanyUuid?: string,
    rightsholderPersonUuid?: string,
    legalRightUuid?: string,
  ): Observable<WithUuid<CompanyLegalRightCompositeEntity>[]> {
    let httpParams = new HttpParams();
    if (companyUuid) {
      httpParams = httpParams.append('company_identifier', companyUuid);
    }
    if (rightsholderCompanyUuid) {
      httpParams = httpParams.append('rightsholder_company_identifier', rightsholderCompanyUuid);
    }
    if (rightsholderPersonUuid) {
      httpParams = httpParams.append('rightsholder_person_identifier', rightsholderPersonUuid);
    }
    if (legalRightUuid) {
      httpParams = httpParams.append('legal_right_uuid', legalRightUuid);
    }
    return this._analysisApiAccess.get<WithUuid<CompanyLegalRightCompositeEntity>[]>(
      'company-legal-right-composite',
      { params: httpParams },
      [AppFeatureKey.base, AppFeatureKey.norwegian_property_data, ...COUNTRY_FEATURES],
      [AppRoleKey.norwegian_property_data],
    );
  }
}
